import {ActionsTitle, ModalSearchWrapper, ProjectsCount} from "./styles";
import {MobileFilterSort} from "../../pages/explore/exploreView";
import {SortIcon} from "../../icons";
import {FlexBox, useBreakpoint, useIsMobile} from "@brg/ui";
import {useTranslation} from "react-i18next";
import {FC, ReactNode, useMemo} from "react";
import {ProjectsSearchBar} from "../../components/projectsSearchBar/projectsSearchBar";
import {SortingTypeIndex} from "../../constants/sortingType";
import { EmployActionsModalWrapper, SendEmployProjectButton, SendProjectsTitle, SubtitleText} from "./employStyles";
import { LayoutConst, useModal } from "core";
import { CloseModalIconMob } from "core/modules/CloseIconNewMob";
import MobileSearchBar from "shared/components/MobileSearchBar/MobileSearchBar";

export type SearchDataT = {
    id: string;
}

interface SendProjectsTitleProps {
    count: number;
    onMobileSortingClick: () => void;
    onSend: () => void;
    onSortingChange: (s: SortingTypeIndex) => void;
    sorting: SortingTypeIndex;
    sendText?: string;
    titleText?: string;
    subtitleText?: string;
    isClosed?: boolean;
    hideFilter?: boolean;
    hideCount?: boolean;
    hideSendButton?: boolean;
    noProjectVisible?: boolean;
    isDisabledSendButton?: boolean;
    isCompetitionModal?: boolean;
    showMobileClose?: boolean;
    searchData?: SearchDataT;
    chooseAllBox?: ReactNode;
    noProjectCheckbox?: ReactNode;
    tabs?: ReactNode;
    sortingMethods?: SortingTypeIndex[];
    checkbox?: boolean;
    hide?: boolean;
    fullTitle?: boolean;
    children?: ReactNode;
}

export const SendProjectsEntity: FC<SendProjectsTitleProps> = ({
    count, 
    hideFilter, 
    hideCount, 
    hideSendButton, 
    noProjectVisible,
    chooseAllBox, 
    onMobileSortingClick, 
    sorting, 
    onSortingChange, 
    onSend, 
    isClosed, 
    children,
    tabs,
    hide = false,
    showMobileClose,
    searchData = undefined, 
    isDisabledSendButton,
    isCompetitionModal, 
    noProjectCheckbox,
    sortingMethods = undefined,
    sendText,
    titleText,
    subtitleText
}) => {

    const {t} = useTranslation();
    const isMobile = useIsMobile();
    const modal = useModal();
    const isS = useBreakpoint(LayoutConst.screen.s - 1);

    const wideSendButton = useMemo(() => (isS && isCompetitionModal), [isS, isCompetitionModal])
    const showSearch = useMemo(() => (searchData?.id), [searchData])

    const searchBar = useMemo(
        () => (
            <ProjectsSearchBar
                isLoading={false}
                sorting={sorting}
                hideRightBar={false}
                hideLeftBar={true}
                hideRightButtons
                onSortingChange={onSortingChange}
                isTagPage={false}
                projectCount={count}
                {...(!!sortingMethods ? {sortingMethods: sortingMethods} : undefined)}
            />
        ),
        [
            sorting,
            onSortingChange,
            sortingMethods,
            count
        ],
    );

    const searchInput = useMemo(() => (
        <ModalSearchWrapper>
            <MobileSearchBar placeholder={t('enter_name_or_title')} competitionId={searchData?.id} />
        </ModalSearchWrapper>
    ), [t, searchData])

    if (hide) {
        return null;
    }

    return <EmployActionsModalWrapper direction="column" gy={24} zeroHeight={isClosed} fullWidth={/*!noProjectVisible*/ true}>
            {!isClosed && <ActionsTitle justify='space-between' justifyMobile='space-between' direction='row' directionMobile="row" style={{ marginBottom: (isS && noProjectCheckbox && !wideSendButton) ? 24 : 0 }} >
                <FlexBox direction="column" directionMobile="column" alignMobile="start" gy={subtitleText ? 8 : 0}>
                    <SendProjectsTitle mainTitle>
                        {titleText || t('competition.select_project')}
                    </SendProjectsTitle>
                    {subtitleText && (
                        <SubtitleText>{subtitleText}</SubtitleText>
                    )}
                    {isMobile && isCompetitionModal && noProjectVisible && !isClosed && noProjectCheckbox} 
                </FlexBox>
                {!hideSendButton && (
                    <FlexBox alignMobile="flex-end" gyMobile={showMobileClose && isMobile ? 16 : 0} direction="column" directionMobile="column">
                        {showMobileClose && isMobile && <CloseModalIconMob onClick={() => modal.hide()} />}
                        {!wideSendButton && (
                            <SendEmployProjectButton width={187} disabled={isDisabledSendButton || hide} onClick={onSend}>
                                {sendText || t('competition.send')}
                            </SendEmployProjectButton>
                        )}
                    </FlexBox>
                )} 
            </ActionsTitle>}
            {wideSendButton && (
                <SendEmployProjectButton staticPosition disabled={isDisabledSendButton || hide} onClick={onSend}>
                    {sendText || t('competition.send')}
                </SendEmployProjectButton>
            )}
            { noProjectVisible && !isClosed && noProjectCheckbox}
            <FlexBox direction='row' justify='space-between' align='center'>
            {!hideCount && 
                <ProjectsCount>
                    {t('competition.selected_projects', {count: count})}
                </ProjectsCount>
            }
            {!!hideCount && !!tabs && tabs}
            {!hideFilter && (isMobile ? (
                <MobileFilterSort onClick={onMobileSortingClick}>
                    <SortIcon/>
                    {t(`sorting_type.${sorting == 1 ? 'latest' : 'popular'}`)}
                </MobileFilterSort>
            ) : searchBar)}
            </FlexBox>
            {chooseAllBox && chooseAllBox}
            {showSearch && searchInput}
        {children}
    </EmployActionsModalWrapper>
}import {ActionsTitle, ModalSearchWrapper, ProjectsCount} from "./styles";
import {MobileFilterSort} from "../../pages/explore/exploreView";
import {SortIcon} from "../../icons";
import {FlexBox, useBreakpoint, useIsMobile} from "@brg/ui";
import {useTranslation} from "react-i18next";
import {FC, ReactNode, useMemo} from "react";
import {ProjectsSearchBar} from "../../components/projectsSearchBar/projectsSearchBar";
import {SortingTypeIndex} from "../../constants/sortingType";
import { EmployActionsModalWrapper, SendEmployProjectButton, SendProjectsTitle, SubtitleText} from "./employStyles";
import { LayoutConst, useModal } from "core";
import { CloseModalIconMob } from "core/modules/CloseIconNewMob";
import MobileSearchBar from "shared/components/MobileSearchBar/MobileSearchBar";

export type SearchDataT = {
    id: string;
}

interface SendProjectsTitleProps {
    count: number;
    onMobileSortingClick: () => void;
    onSend: () => void;
    onSortingChange: (s: SortingTypeIndex) => void;
    sorting: SortingTypeIndex;
    sendText?: string;
    titleText?: string;
    subtitleText?: string;
    isClosed?: boolean;
    hideFilter?: boolean;
    hideCount?: boolean;
    hideSendButton?: boolean;
    noProjectVisible?: boolean;
    isDisabledSendButton?: boolean;
    isCompetitionModal?: boolean;
    showMobileClose?: boolean;
    searchData?: SearchDataT;
    chooseAllBox?: ReactNode;
    noProjectCheckbox?: ReactNode;
    tabs?: ReactNode;
    sortingMethods?: SortingTypeIndex[];
    checkbox?: boolean;
    hide?: boolean;
    fullTitle?: boolean;
    children?: ReactNode;
}

export const SendProjectsEntity: FC<SendProjectsTitleProps> = ({
    count, 
    hideFilter, 
    hideCount, 
    hideSendButton, 
    noProjectVisible,
    chooseAllBox, 
    onMobileSortingClick, 
    sorting, 
    onSortingChange, 
    onSend, 
    isClosed, 
    children,
    tabs,
    hide = false,
    showMobileClose,
    searchData = undefined, 
    isDisabledSendButton,
    isCompetitionModal, 
    noProjectCheckbox,
    sortingMethods = undefined,
    sendText,
    titleText,
    subtitleText
}) => {

    const {t} = useTranslation();
    const isMobile = useIsMobile();
    const modal = useModal();
    const isS = useBreakpoint(LayoutConst.screen.s - 1);

    const wideSendButton = useMemo(() => (isS && isCompetitionModal), [isS, isCompetitionModal])
    const showSearch = useMemo(() => (searchData?.id), [searchData])

    const searchBar = useMemo(
        () => (
            <ProjectsSearchBar
                isLoading={false}
                sorting={sorting}
                hideRightBar={false}
                hideLeftBar={true}
                hideRightButtons
                onSortingChange={onSortingChange}
                isTagPage={false}
                projectCount={count}
                {...(!!sortingMethods ? {sortingMethods: sortingMethods} : undefined)}
            />
        ),
        [
            sorting,
            onSortingChange,
            sortingMethods,
            count
        ],
    );

    const searchInput = useMemo(() => (
        <ModalSearchWrapper>
            <MobileSearchBar placeholder={t('enter_name_or_title')} competitionId={searchData?.id} />
        </ModalSearchWrapper>
    ), [t, searchData])

    if (hide) {
        return null;
    }

    return <EmployActionsModalWrapper direction="column" gy={24} zeroHeight={isClosed} fullWidth={/*!noProjectVisible*/ true}>
            {!isClosed && <ActionsTitle justify='space-between' justifyMobile='space-between' direction='row' directionMobile="row" style={{ marginBottom: (isS && noProjectCheckbox && !wideSendButton) ? 24 : 0 }} >
                <FlexBox direction="column" directionMobile="column" alignMobile="start" gy={subtitleText ? 8 : 0}>
                    <SendProjectsTitle mainTitle>
                        {titleText || t('competition.select_project')}
                    </SendProjectsTitle>
                    {subtitleText && (
                        <SubtitleText>{subtitleText}</SubtitleText>
                    )}
                    {isMobile && isCompetitionModal && noProjectVisible && !isClosed && noProjectCheckbox} 
                </FlexBox>
                {!hideSendButton && (
                    <FlexBox alignMobile="flex-end" gyMobile={showMobileClose && isMobile ? 16 : 0} direction="column" directionMobile="column">
                        {showMobileClose && isMobile && <CloseModalIconMob onClick={() => modal.hide()} />}
                        {!wideSendButton && (
                            <SendEmployProjectButton width={187} disabled={isDisabledSendButton || hide} onClick={onSend}>
                                {sendText || t('competition.send')}
                            </SendEmployProjectButton>
                        )}
                    </FlexBox>
                )} 
            </ActionsTitle>}
            {wideSendButton && (
                <SendEmployProjectButton staticPosition disabled={isDisabledSendButton || hide} onClick={onSend}>
                    {sendText || t('competition.send')}
                </SendEmployProjectButton>
            )}
            { noProjectVisible && !isClosed && noProjectCheckbox}
            <FlexBox direction='row' justify='space-between' align='center'>
            {!hideCount && 
                <ProjectsCount>
                    {t('competition.selected_projects', {count: count})}
                </ProjectsCount>
            }
            {!!hideCount && !!tabs && tabs}
            {!hideFilter && (isMobile ? (
                <MobileFilterSort onClick={onMobileSortingClick}>
                    <SortIcon/>
                    {t(`sorting_type.${sorting == 1 ? 'latest' : 'popular'}`)}
                </MobileFilterSort>
            ) : searchBar)}
            </FlexBox>
            {chooseAllBox && chooseAllBox}
            {showSearch && searchInput}
        {children}
    </EmployActionsModalWrapper>
}